import { pick } from '../utils/object'
import request from './request'
import store from 'storejs'

const baseURL = `https://api.crossref.org/`
const workURL = `${baseURL}works/`

export default {
    getDoi: (doi) => {
        const cache = store.get(doi)
        if (cache) {
            return Promise.resolve(cache)
        }
        return request(`${workURL}${doi}`)
            .then(res => res.json())
            .then(res => {
                const status = res.status;
                const info = pick(res.message, [
                    'container-title',
                    'short-container-title',
                    'issued', // 包含时间信息
                    'author',
                    'title',
                    'page',
                    'volume',
                    'DOI'
                ])
                const result = {
                    status,
                    info
                };
                store.set(doi, result)
                return result
            })
            .catch(err => {
                console.err(err)
            })
    }
}


// WEBPACK FOOTER //
// ./src/services/http.js